export default "__VITE_ASSET__lV3ByhT8__"